type LogoutConfirmDialogProps = {
  error: string;
  isSubmitting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function LogoutConfirmDialog({
  error,
  isSubmitting,
  onCancel,
  onConfirm,
}: LogoutConfirmDialogProps) {
  function handleBackdropClick() {
    if (!isSubmitting) {
      onCancel();
    }
  }

  return (
    <div className="student-logout-dialog-backdrop" role="presentation" onClick={handleBackdropClick}>
      <div
        aria-busy={isSubmitting}
        aria-describedby="logout-dialog-description"
        aria-labelledby="logout-dialog-title"
        aria-modal="true"
        className="student-logout-dialog"
        role="dialog"
        onClick={(event) => event.stopPropagation()}
      >
        <div>
          <h3 id="logout-dialog-title">退出登录？</h3>
          <p id="logout-dialog-description">退出后需要重新输入手机号和验证码。</p>
          {error ? <p className="logout-dialog-error" role="alert">{error}</p> : null}
        </div>
        <div className="student-logout-actions">
          <button className="student-logout-secondary" type="button" disabled={isSubmitting} onClick={onCancel}>
            取消
          </button>
          <button className="student-logout-primary" type="button" disabled={isSubmitting} onClick={onConfirm}>
            {isSubmitting ? "正在退出…" : "退出登录"}
          </button>
        </div>
      </div>
    </div>
  );
}
